import ProtectedController from 'volta/controllers/protected-controller';

export default class DashboardController extends ProtectedController {
  queryParams = [
    'warehouse',
    'supplier',
    'deliveryWorkshop',
    'workshop',
    'acqCode',
    'tags',
    'planner',
    'timePeriod',
    'timePeriodCount',
    'tagsOperator'
  ];
}
